import { createSelector } from 'reselect';

const stateSelector = state => state.app;
export const pubKeySelector = createSelector(stateSelector, state => state && state.stripe && state.stripe.pubKey);
export const adyenPubKeySelector = createSelector(stateSelector, state => state.adyen.pubKey);
// GET /user/mop/stripe/key returns the configured PSP's key whatever the PSP, and
// fills app.stripe.pubKey; app.adyen.pubKey is only set when app.paymentProvider is.
export const pspPublishableKeySelector = createSelector(
    stateSelector,
    state => (state.adyen && state.adyen.pubKey) || (state.stripe && state.stripe.pubKey) || null
);
export const clientSecretSelector = createSelector(stateSelector, state => state.stripe.clientSecret);
export const setupIntentIdSelector = createSelector(stateSelector, state => state.stripe.setupIntentId);
export const appFetchingSelector = createSelector(stateSelector, state => state.fetching);
export const adyenNextActionSelector = createSelector(stateSelector, state => state.adyen.nextAction);
export const adyenStatus3dsSelector = createSelector(stateSelector, state => state.adyen.status3ds);
export const adyenIs3dsRequiredSelector = createSelector(stateSelector, state => state.adyen.is3dsRequired);
export const paymentProviderSelector = createSelector(stateSelector, state => state.paymentProvider);
export const defaultLocaleSelector = createSelector(stateSelector, state => state.defaultLocale);
export const apiConfigSelector = createSelector(stateSelector, state => state.apiConfig);

// Sessions flow (ISJ-8831)
export const adyenSessionSelector = createSelector(stateSelector, state => state.adyen.session);
export const adyenSessionErrorSelector = createSelector(stateSelector, state => state.adyen.sessionError);
